import Section from '../Section'
import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'
import { defineMessages, useIntl } from 'react-intl'
import { ListingDetailsListing } from '../../../../types/listings'
import { selectFormattedListingItems } from '../../../../store/selectors/listings'
import { DataProvidedByMlsAbbrevAndNumber } from '../../Compliance/DataProvidedByMlsAbbrevAndNumber'

import styles from './HomeDetails.module.scss'

export const MSG = defineMessages({
  header: {
    id: 'HomeSearch.listingDetails.homeDetails',
    defaultMessage: 'Home Details',
  },
})

export interface HomeDetailsProps {
  className?: string
  listing: ListingDetailsListing
}

export const HomeDetails = ({ className, listing }: HomeDetailsProps) => {
  const intl = useIntl()
  const items = useSelector(selectFormattedListingItems)

  if (isEmpty(items)) return null

  return (
    <Section className={className}>
      <Section.Heading>{intl.formatMessage(MSG.header)}</Section.Heading>
      <Section.Body>
        <ul className={styles.features}>
          {items.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <DataProvidedByMlsAbbrevAndNumber
          className={styles.dataProvidedBy}
          listing={listing}
        />
      </Section.Body>
    </Section>
  )
}
